/**
 * Hiragana -> galmoji.
 *
 * Ported verbatim from galjp v4 (lib/chars/hiragana.json). The values are intentionally
 * unchanged — see docs/DESIGN.md premise 3. Regenerate with:
 *   npm run data:port
 */
export const hiragana: Readonly<Record<string, string>> = {
  あ: 'क॑',
  い: 'ﾚヽ',
  う: 'כֿ',
  え: '之',
  お: 'ょゝ',
  か: 'ｶゝ',
  き: '(≠',
  く: '＜',
  け: 'ﾚﾅ',
  こ: '⊇',
  さ: '±',
  し: 'Ｕ',
  す: '￡',
  せ: '世',
  そ: 'ƺ',
  た: 'ﾅﾆ',
  ち: 'ㄘ',
  つ: '⊃',
  て: 'τ',
  と: '｀⊂',
  な: 'ﾅょ',
  に: 'ﾚﾆ',
  ぬ: 'йu',
  ね: '൹',
  の: 'σ',
  は: 'ﾚ￡',
  ひ: 'ᘮ',
  ふ: '､ζ,',
  へ: '∧',
  ほ: 'ﾚま',
  ま: 'ма',
  み: 'ゐ',
  む: '￡ヽ',
  め: 'め',
  も: '₺',
  や: '兯',
  ゆ: 'ゅ',
  よ: 'ょ',
  ら: 'ʖˋ',
  り: 'ﾚ)',
  る: 'ゑ',
  れ: 'яё',
  ろ: 'З',
  わ: 'ゎ',
  を: 'ξ',
  ん: 'ω',
  ゔ: 'כֿ”',
  が: 'ｶゝ”',
  ぎ: '(≠”',
  ぐ: '＜”',
  げ: 'ﾚﾅ”',
  ご: '⊇”',
  ざ: '±”',
  じ: 'Ｕ”',
  ず: '￡”',
  ぜ: '世”',
  ぞ: 'ƺ”',
  だ: 'ﾅﾆ”',
  ぢ: 'ㄘ”',
  づ: '⊃”',
  で: 'τ”',
  ど: '｀⊂”',
  ば: 'ﾚ￡”',
  び: 'ひ”',
  ぶ: '､ζ,”',
  べ: '∧”',
  ぼ: 'ﾚま”',
  ぱ: 'ﾚ￡o',
  ぴ: 'ひo',
  ぷ: '､ζ,o',
  ぺ: '∧o',
  ぽ: 'ﾚまo',
  ぁ: 'क॑',
  ぃ: 'ﾚヽ',
  ぅ: 'כֿ',
  ぇ: '之',
  ぉ: 'ょゝ',
  っ: '⊃',
  ゃ: '兯',
  ゅ: 'ゅ',
  ょ: 'ょ',
  ゎ: 'ゎ',
  ー: '→',
};
